/**
 * Утилита для работы с видеоссылками разных хостингов
 */

// Функция определения видеохостинга и получения ID видео
export function getVideoEmbedUrl(videoUrl) {
  if (!videoUrl) return null;
  
  // YouTube
  const youtubeRegex = /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\/?\?v=|\/embed\/|\/)([^\s&\?\/\#]+)/;
  const youtubeMatch = videoUrl.match(youtubeRegex);
  
  if (youtubeMatch && youtubeMatch[1]) {
    return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
  }
  
  // Rutube
  const rutubeRegex = /(?:https?:\/\/)?(?:www\.|m\.)?rutube\.ru\/(?:video|play\/embed)\/([^\s&\?\/\#]+)/;
  const rutubeMatch = videoUrl.match(rutubeRegex);
  
  if (rutubeMatch && rutubeMatch[1]) {
    return `https://rutube.ru/play/embed/${rutubeMatch[1]}`;
  }
  
  // Если формат не распознан, возвращаем null или исходную ссылку
  return videoUrl;
}

// Проверяет, является ли ссылка видеоссылкой одного из поддерживаемых хостингов
export function isVideoUrl(url) {
  if (!url) return false;
  
  const patterns = [
    /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:be)?\.(?:com|be)/,
    /(?:https?:\/\/)?(?:www\.|m\.)?rutube\.ru/
  ];
  
  return patterns.some(pattern => pattern.test(url));
} 